module.exports = __webpack_public_path__ + "static/img/a2.0cca7ce6.png";